"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrimaryInsuranceLicense = exports.defaultInsuranceLicenseTypes = void 0;
exports.defaultInsuranceLicenseTypes = {
    EXCESS_LINES_LICENSEE: "Excess Lines Licensee",
    DESIGNATED_RESPONSIBLE_PRODUCER: "Designated Responsible Producer"
};
const getPrimaryInsuranceLicense = (licenses) => {
    let license = licenses.find((aLicense) => aLicense.type === exports.defaultInsuranceLicenseTypes.EXCESS_LINES_LICENSEE);
    if (!license) {
        [license] = licenses;
    }
    return license;
};
exports.getPrimaryInsuranceLicense = getPrimaryInsuranceLicense;
//# sourceMappingURL=types.js.map